import moment from 'moment';

const EXPIRED_DAYS_COUNT = 90;

export const getIsLocationExpired = ({ confirmedAt }) => {
  if (!confirmedAt) {
    return true
  }
  
  const modifiedDate = moment(confirmedAt);
  const now = moment();
  const daysAgo = now.diff(modifiedDate, 'days');

  return daysAgo >= EXPIRED_DAYS_COUNT
}